import { Button } from '@/components/ui/Button'
import type { JobStatus } from '@/features/recruiter/api/jobs.api'
import { useChangeJobStatus } from '@/features/recruiter/hooks/useJobs'

// Mirrors JobStatus::canTransitionTo() in backend/app/Enums/JobStatus.php —
// lifecycle only moves forward, archived is terminal.
const TRANSITIONS: Record<JobStatus, JobStatus[]> = {
  draft: ['published', 'archived'],
  published: ['paused', 'closed', 'archived'],
  paused: ['published', 'closed', 'archived'],
  closed: ['archived'],
  archived: [],
}

function actionLabel(current: JobStatus, target: JobStatus): string {
  if (target === 'published') return current === 'paused' ? 'Resume' : 'Publish'
  if (target === 'paused') return 'Pause'
  if (target === 'closed') return 'Close'
  if (target === 'archived') return 'Archive'
  return target
}

export function JobStatusActions({ jobId, status }: { jobId: number; status: JobStatus }) {
  const changeStatus = useChangeJobStatus(jobId)
  const targets = TRANSITIONS[status]

  if (targets.length === 0) return null

  return (
    <div className="d-flex gap-2 flex-wrap">
      {targets.map((target) => (
        <Button
          key={target}
          variant={target === 'closed' || target === 'archived' ? 'danger' : 'secondary'}
          confirmTitle={`${actionLabel(status, target)} this job?`}
          loading={changeStatus.isPending}
          onClick={() => changeStatus.mutate(target)}
        >
          {actionLabel(status, target)}
        </Button>
      ))}
    </div>
  )
}
